// 表单校验工具：登录/注册/卡密/分享码的即时格式校验

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim())

export const isValidPassword = (v) => typeof v === 'string' && v.length >= 6

export const isValidUsername = (v) => {
  const t = (v || '').trim()
  return t.length >= 2 && t.length <= 20
}

// 卡密格式：XXXX-XXXX-XXXX-XXXX（字母数字，自动大写）
export const isValidActivationCode = (v) =>
  /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test((v || '').trim())

// 分享码格式：6 位字母数字
export const isValidShareCode = (v) => /^[A-Z0-9]{6}$/.test((v || '').trim())

// 卡密输入自动格式化：大写、去非字母数字、每 4 位加横线
export function formatActivationCode(v) {
  const clean = (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16)
  return clean.replace(/(.{4})(?=.)/g, '$1-')
}
